/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Utility pro práci s řetězci
 */
class StringUtil {
  /**
   * Vrátí všechny nalezeného výskytu hledané hodnoty.
   * Funguje stejně jako standardní `String#indexOf`, ale vrací všechny výskyty
   * a ne jen první.
   *
   * Zdroje:
   * - [Originální implementace](https://stackoverflow.com/a/14482123/8315965)
   * - [ECMAScript `String#indexOf`](https://tc39.es/ecma262/#sec-string.prototype.indexof)
   * - [MDN `String#indexOf`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/indexOf)
   * @param {string} string Řetězec, ve kterém se hledají výskyty.
   * @param {string} searchValue Řetězec, jehož výskyty se hledají.
   * @param {Object} [opts={}]
   * @param {number} [opts.max] Maximální počet výskytů, který se hledá.
   * @returns {number}
   */
  indexesOf(string, searchValue, { max = Infinity } = {}) {
    const { length } = string;
    const result = [];
    let index = -1;
    let countdown = max;
    // TODO Refaktorizovat originální zpracování bez ++ a --
    // eslint-disable-next-line no-plusplus
    while (countdown-- && index++ < length) {
      index = string.indexOf(searchValue, index);
      if (index === -1) {
        break;
      }
      result.push(index);
    }
    return result;
  }

  /**
   * Vrátí index n-tého nalezeného výskytu hledané hodnoty.
   * Funguje stejně jako standardní `String#indexOf`, ale vrací n-tý výskyt
   * a ne jen první.
   *
   * Zdroje:
   * - [Originální implementace](https://stackoverflow.com/a/14482123/8315965)
   * - [ECMAScript `String#indexOf`](https://tc39.es/ecma262/#sec-string.prototype.indexof)
   * - [MDN `String#indexOf`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/indexOf)
   * @param {string} string Řetězec, ve kterém se hledají výskyty.
   * @param {string} searchValue Řetězec, jehož výskyty se hledají.
   * @param {number} nth Pořadí výskytu, který se má hledat.
   * @returns {number}
   */
  nthIndexOf(string, searchValue, nth) {
    const { length } = string;
    let index = -1;
    let countdown = nth;
    // TODO Refaktorizovat originální zpracování bez ++ a --
    // eslint-disable-next-line no-plusplus
    while (countdown-- && index++ < length) {
      index = string.indexOf(searchValue, index);
      if (index === -1) {
        break;
      }
    }
    return index;
  }
}

export default StringUtil;
